import styled from 'styled-components';
import EnvironmentalAspectsAssessmentCardCheckbox from './EnvironmentalAspectsAssessmentCardCheckbox';
import EnvironmentalAspectsAssessmentCardSwitch from './EnvironmentalAspectsAssessmentCardSwitch';

export default function EnvironmentalAspectsAssessmentAspectContainer({
  id,
  type,
}) {
  return (
    <Container className="pt-2">
      <CheckboxContainer>
        <EnvironmentalAspectsAssessmentCardCheckbox
          id={id}
        />
      </CheckboxContainer>
      <EnvironmentalAspectsAssessmentCardSwitch
        type={type}
        id={id}
      />
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
`;

const CheckboxContainer = styled.div`
  height: 160px;
  display: flex;
  align-items: center;
`;
